import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const PUBLICROUTES = [
  "/crm/cdha",
  "/crm/tracuu_cls",
  "/crm/tracuu_cls/ketquaxetnghiem",
  "/medic-info",
  "/y-te-medic-info",
  "/customer/idea-initiative/success",
  "/customer/idea-initiative/form",
  "/customer/ghi-nhan-yeu-cau",
  "/customer/ghi-nhan-yeu-cau/detail",
  "/customer/ghi-nhan-yeu-cau/success",
  "/customer/dang-ky-dich-vu-tai-nha/success",
  "/customer/dang-ky-dich-vu-tai-nha",
  "/documentviewer",
  "/app/asset/view",
  "/customer/chu-ky-ksk-doan"
];

const PublicRoute = () => {
  const { pathname } = useLocation();
  const { token, redirect, mustChangePassword } = useSelector((state) => state.auth);
  const isPublicRoute = PUBLICROUTES.find((item) => pathname.includes(item));
  // Route public (vd /documentviewer, /app/asset/view...) cho xem kể cả khi đã đăng nhập.
  // Chỉ đá về dashboard khi ĐÃ đăng nhập VÀ KHÔNG phải route public.
  if (token && !isPublicRoute) {
    if (mustChangePassword) {
      return <Navigate to={`${APP_PREFIX_PATH}/hrm/setting-account/change-password?mustChange=1`} replace />;
    }
    return <Navigate to={redirect} replace />;
  }
  return <Outlet />;
};

export default PublicRoute;
